import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import DialogCTA from '@/components/Dialogs/DialogCTA';

// STYLES
import { Section as SectionStyles, WPContent as WPContentStyles } from '@/styles/wp';

export const Section = styled(SectionStyles)`
  padding-top: 55px;
`;

export const WPContent = styled(WPContentStyles)`
  padding-top: 35px;
  .markdown {
    white-space: normal !important;
  }
`;

export const DialogCTAStyled = styled(DialogCTA)`
  ${breakpoints.up('md')} {
    .MuiDialogContent-root {
      padding: 64px 40px 40px;
    }

    &.find-my-bundle {
      .MuiPaper-root {
        max-width: 580px;
      }

      .dialog-cta {
        &__subtitle {
          margin: 24px 0;
        }

        &__icon {
          font-size: 40px;
        }
      }
    }

    &.find-internet-offers {
      .MuiPaper-root {
        max-width: 515px;
      }

      .dialog-cta__subtitle {
        margin: 16px 0 32px;
      }
    }
  }
`;

export default Section;
